import { isSystemRequestUrl } from '../utils/validateRequestUrl'

export default function (context) {
  const url = context?.req?.url
  if (!url || isSystemRequestUrl(url)) {
    return
  }
  if (process.server) {
    context.store.commit(
      'userIp/SET_USER_IP',
      context.req.headers['x-forwarded-for']
    )
    context.customIP = context.req.headers['x-forwarded-for']
  }
}
